import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import Header from "../common/header/Header";
import SecondaryButton from "../common/buttons/SecondaryButton";

import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import MultiSelectWithCheckboxEdit from "./multiselect-locations-edit";

const EditRecruiters = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [addfirstName, setAddfirstName] = useState("");
  const [eclinProId, setEclinProId] = useState("");
  const [addlastName, setAddlastName] = useState("");
  const [addrecruiterEmail, setAddrecruiterEmail] = useState("");
  const [addrecruiterClinicId, setAddrecruiterClinicId] = useState("");
  const [recruiterById, setRecruiterById] = useState([]);
  const [toasts, setToasts] = useState([]);
  const [apiLoader, setApiLoader] = useState(false);
  const [errors, setErrors] = useState({});

  const fetchData = async () => {
    const response = await axios
      .get(`${ENDPOINTS.RECRUITERS.RECRUITER_BY_ID}?recruiterID=${id}`)
      .then((res) => {
        setRecruiterById(res.data.data);
        setAddfirstName(res.data.data.firstName);
        setAddlastName(res.data.data.lastName);
        setAddrecruiterEmail(res.data.data.recruiterEmail);
        setEclinProId(res.data.data.eclinProUserID);
        const fetchRecId = res.data.data.clinicalRecruiterData;
        const recruiterByIdAre = fetchRecId.map((i) => i.clinicalInfoID);
        setAddrecruiterClinicId(recruiterByIdAre);
      });
  };

  // fetching clinic info
  const [clinicInfoId, setclinicInfoId] = useState([]);

  const fetchClinicData = async () => {
    await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO).then((res) => {
      const response = JSON.stringify(res.data.data);
      setclinicInfoId(JSON.parse(response));
    });
  };
  useEffect(() => {
    fetchData();
    fetchClinicData();
  }, []);

  // to get clinicinfo id

  const [selectedClinicId, setSelectedClinicId] = useState([]);
  useEffect(() => {
    setSelectedClinicId([...addrecruiterClinicId]);
  }, [addrecruiterClinicId]);
  const recruiterOptions = clinicInfoId.map((clinic) => ({
    value: clinic.name,
    label: clinic.name,
    id: clinic.clinicalInfoID, // Custom property to store ID
  }));

  // Handle location selection
  const handleSelectChange = ({ selectedIds }) => {
    setSelectedClinicId(selectedIds); // Update selected recruiter clinic IDs
  };

  // Pre select Clinic IDs

  const editSelectedIds = [addrecruiterClinicId];

  // edit popup
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    isError: false,
  });
  const closePopup = () => {
    setPopup({ show: false, message: "", isError: false });
  };

  const validateFields = () => {
    const newErrors = {};

    if (!addfirstName.trim())
      newErrors.addfirstName = "First name is required.";
    if (!addlastName.trim()) newErrors.addlastName = "Last name is required.";
    // if (!addrecruiterEmail.trim()) {
    //     newErrors.addrecruiterEmail = "Email is required.";
    // } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addrecruiterEmail)) {
    //     newErrors.addrecruiterEmail = "Invalid email format.";
    // }
    if (!addrecruiterClinicId)
      newErrors.addrecruiterClinicId = "Clinic is required.";
    if (!eclinProId) newErrors.eclinProId = "EclinPro ID is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditClinic = async (e) => {
   
    e.preventDefault();

    const isValid = validateFields();
    if (!isValid) return;
 setApiLoader(true);
    const ResponseBody = {
      recruiterID: id,
      firstName: addfirstName,
      lastName: addlastName,
      recruiterEmail: addrecruiterEmail,
      clinicalInfoIDs: selectedClinicId,
      eclinProUserID: eclinProId ? eclinProId : 0,
    };
    try {
      const response = await axios.put(
        ENDPOINTS.RECRUITERS.EDIT_RECRUITERS,
        ResponseBody
      );
      setApiLoader(false);
      // setPopup({ show: true, message: "The recruiter details has been updated successfully!", isError: false });
      addToast("Recruiter has been updated successfully.", "success");
    } catch (error) {
      // console.error("Error updating data:", error);
      // setPopup({ show: true, message: error, isError: true });
      setApiLoader(false);
      addToast("Failed to update the recruiter.", "error");
    }
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  return (
    <>
      <Header headertitle="Edit Recruiter" backbutton={true} />

      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      <div className="main-body w-[80%] p-8">
        <div className="text_color font-normal text-[16px] text-[#373737] font-mont">
          Seamlessly onboard and empower your recruitment team.
        </div>
        <form onSubmit={handleEditClinic}>
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div>
              <label
                for="clinicName"
                class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
              >
                First Name <span className="aestrick_color">*</span>
              </label>
              <input
                type="text"
                name="firstName"
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                required
                defaultValue={addfirstName}
                onChange={(e) => setAddfirstName(e.target.value)}
              />
              {errors.addfirstName && (
                <p className="text-red-600">{errors.addfirstName}</p>
              )}
            </div>
            <div>
              <label
                for="lastname"
                class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
              >
                Last Name <span className="aestrick_color">*</span>
              </label>
              <input
                type="text"
                name="lastName"
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                required
                defaultValue={recruiterById.lastName}
                onChange={(e) => setAddlastName(e.target.value)}
              />
              {errors.addlastName && (
                <p className="text-red-600">{errors.addlastName}</p>
              )}
            </div>
            <div>
              <label
                for="recruiterEmail"
                class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
              >
                Email Id <span className="aestrick_color">*</span>
              </label>
              {/* <input
                            type="text"
                            name="recruiterEmail"
                            className="field_bg border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                            required
                            defaultValue={recruiterById.recruiterEmail}
                            onChange={(e) => setAddrecruiterEmail(e.target.value)}
                        /> */}
              <input
                type="text"
                name="recruiterEmail"
                className="field_bg border_color border text-sm rounded-lg block w-full p-2.5 h-12 cursor-not-allowed"
                required
                defaultValue={recruiterById.recruiterEmail}
                disabled
              />
              {errors.addrecruiterEmail && (
                <p className="text-red-600">{errors.addrecruiterEmail}</p>
              )}
            </div>
            <div>
              <label
                for="clinicName"
                class="block font-semibold title_color pb-4 text-[16px] text-[#1B2A3D] font-mont"
              >
                Location <span className="aestrick_color">*</span>
              </label>
              <div
                className="border_color border text-sm rounded-lg block w-full p-1 appearance-none"
                style={{ minHeight: "3rem" }}
              >
                {recruiterOptions && (
                  <MultiSelectWithCheckboxEdit
                    options={recruiterOptions}
                    selectedValues={selectedClinicId}
                    onChange={handleSelectChange}
                  />
                )}
                {errors.addrecruiterClinicId && (
                  <p className="text-red-600">{errors.addrecruiterClinicId}</p>
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div>
              <label
                htmlFor="eclinProId"
                className="block form_label_color pb-4"
              >
                EclinPro ID <span className="aestrick_color">*</span>
              </label>

              <input
                type="number"
                id="eclinProId"
                name="eclinProId"
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                placeholder="EclinPro ID"
                value={eclinProId || ""}
                onChange={(e) => setEclinProId(e.target.value)}
                min="0"
              />

              {errors.eclinProId && (
                <p className="text-red-500 text-sm">{errors.eclinProId}</p>
              )}
            </div>
          </div>

          <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
            <button
              type="submit"
              className="btn-primary-base-bar primary_btn"
              disabled={apiLoader}
            >
              {apiLoader ? (
                <div className="flex justify-center">
                  <div className="mini-spinner "></div>
                </div>
              ) : (
                "Update"
              )}
            </button>
            <BackButton />
          </div>
        </form>
      </div>
    </>
  );
};

export default EditRecruiters;
